import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Width-driven layout flags:
 * - isMobile:  < 900px  (phones, tablets in portrait)
 * - isTablet:  900–1199px (iPad Pro 11" landscape, small laptops)
 * - isDesktop: ≥ 1200px
 * - isPhone:   < 600px
 * - isTouch:   coarse pointer (phones, iPad) — larger targets, tap instead of hover
 */
export const useResponsive = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const isTouch = useMediaQuery('(pointer: coarse)');

  return { isMobile, isTablet, isDesktop, isPhone, isTouch };
};
